import { FC, memo } from "react";
import { useRecoilValue } from "recoil";

import { usePageContext } from "@ryde/redux";
import {
  liveMapAutofitSuspendedAtom,
  liveMapRideTrackingRoutesSF,
  selectedLiveMapMapRidesSF,
} from "@ryde/shared";

import { LiveMapAutofitLoader } from "./live-map.map.autofit-loader";
import { LiveMapMapInner } from "./live-map.map.inner";
import {
  LiveMapMapDataLayer,
  LiveMapMapStyled,
  LiveMapMapWrapper,
} from "./live-map.map.styled";

const LiveMapMapData: FC = () => {
  const { entity } = usePageContext();

  const mapRides = useRecoilValue(selectedLiveMapMapRidesSF(entity));

  const trackingCarRoutes = useRecoilValue(liveMapRideTrackingRoutesSF(entity));

  return (
    <LiveMapMapInner
      mapRides={mapRides}
      trackingCarRoutes={trackingCarRoutes}
    />
  );
};

const LiveMapMapComponent: FC = () => {
  const isMapRenderDeferred = useRecoilValue(liveMapAutofitSuspendedAtom);

  return (
    <LiveMapMapWrapper>
      <LiveMapMapStyled>
        <LiveMapMapDataLayer $mapDeferred={isMapRenderDeferred}>
          <LiveMapMapData />
        </LiveMapMapDataLayer>
        {isMapRenderDeferred && <LiveMapAutofitLoader />}
      </LiveMapMapStyled>
    </LiveMapMapWrapper>
  );
};

export const LiveMapMap = memo(LiveMapMapComponent);
